import { getMerchantsODataUrl } from '../../config/api';
import {
  coerceMerchantODataRow,
  type MerchantODataRow,
} from '../../models/merchant';

function formatODataKey(id: string): string {
  if (/^\d+$/.test(id)) {
    return id;
  }
  const escaped = id.replace(/'/g, "''");
  return `'${escaped}'`;
}

export async function fetchMerchantById(
  merchantId: string,
  getAccessToken: () => Promise<string | undefined>
): Promise<MerchantODataRow> {
  const base = getMerchantsODataUrl();
  if (!base) {
    throw new Error(
      'API base URL is not configured. Set REACT_APP_API_BASE_URL or uncomment API_BASE_URL in src/config/api.ts.'
    );
  }

  const url = `${base}?$filter=Id eq ${formatODataKey(merchantId)}`;
  const token = await getAccessToken();
  const headers: HeadersInit = {
    Accept: 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, { headers });
  if (!response.ok) {
    const body = await response.text();
    throw new Error(
      body || `Request failed with status ${response.status}`
    );
  }

  const body = await response.json();
  return coerceMerchantODataRow(body.value[0]);
}
